import { Dispatch } from 'redux';
import { RESET } from './types';

function reset() {
  return function action(dispatch: Dispatch) {
    dispatch({
      type: RESET,
    });
  };
}

export default reset;
